import VueRouter, { Location, Route } from 'vue-router';

export const toFilter = <T extends string>(currentFilter: T, currentRoute: Route): Route => ({
	...currentRoute,
	params: { ...currentRoute.params, currentFilter },
});

interface TitledMeta {
	title: string;
}

export function onRouteChange(currentRoute: Route): void {
	const title = currentRoute.matched.slice().map((r) => (r.meta as TitledMeta).title as string).reverse().join(' - ');
	document.title = title;
	gtag('event', 'page_view', {
		page_title: title,
		page_location: currentRoute.path,
		send_to: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
	});
}

export type RouteQueryValue = Route['query'][keyof Route['query']];

export function setInQuerySingle(router: VueRouter, currentRoute: Route, key: string, val: RouteQueryValue): Location {
	return setInQuery(router, currentRoute, { [key]: val });
}

export function setInQuery(router: VueRouter, currentRoute: Route, newQuery: Location['query']): Location {
	return router.resolve(
		{ query: { ...currentRoute.query, ...newQuery } },
		currentRoute,
		true,
	).location;
}
